/*
 * SPDX-FileCopyrightText: 2023 The HedgeDoc developers (see AUTHORS file)
 *
 * SPDX-License-Identifier: AGPL-3.0-only
 */
import { useBooleanState } from '../../../hooks/common/use-boolean-state'
import { cypressId } from '../../../utils/cypress-attribute'
import { IconButton } from '../../common/icon-button/icon-button'
import { SettingsModal } from './settings-modal'
import React, { Fragment } from 'react'
import type { ButtonProps } from 'react-bootstrap'
import { Gear as IconGear } from 'react-bootstrap-icons'

export type SettingsButtonProps = Omit<ButtonProps, 'onClick'>
/**
 * Renders a button that opens the settings modal, including the info of the opened note.
 * It is shown to users who are not logged in, logged-in users open the settings from their user menu.
 */
export const SettingsButton: React.FC<SettingsButtonProps> = (props) => {
  const [show, showModal, hideModal] = useBooleanState(false)

  return (
    <Fragment>
      <IconButton {...props} {...cypressId('settingsButton')} onClick={showModal} icon={IconGear} variant={'app-bar'} />
      <SettingsModal show={show} onHide={hideModal} showNoteInfo={true} />
    </Fragment>
  )
}
